import React, { useEffect } from "react";
import { Route, Switch, withRouter, useLocation } from "react-router-dom";
import audit from "./Audit/Audit.jsx";
import locationChecker from "./SearchLocationChecker/SearchLocationCheck";
import home from "./Home/Home";
import advancedSearch from "./AdvancedSearch/AdvancedSearch.jsx";
import reviewCalculator from "./ReviewCalculator/ReviewCalculator.jsx";
import structuredData from "./StructuredData/StructuredData.jsx";
import auditStoreLocator from "./AuditStoreLocator/AuditStoreLocator.jsx";
import reviewSemanticAnalysis from "./ReviewSemanticAnalysis/ReviewSemanticAnalysis.jsx";
import gbpCategories from "./GbpCategories/GbpCategories.jsx";
import NotFound from "./NotFound/NotFound.jsx";
import HeaderApp from "../components/Header/Header";
import "../components/ui/ui.scss";
import { ROUTES, LANGS, isLive } from "../i18n/routes";

// Page component of each route id (URLs are in src/i18n/routes.js).
const PAGES = {
  home,
  gbpAudit: audit,
  storeLocatorAudit: auditStoreLocator,
  localSerpChecker: locationChecker,
  reviewSentimentAnalysis: reviewSemanticAnalysis,
  reviewCalculator,
  schemaGenerator: structuredData,
  gbpCategories,
  advancedSearch,
};

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

const App = () => {
  return (
    <div className="App main">
      <ScrollToTop />
      <header className="app-header">
        <HeaderApp />
      </header>
      <main className="app-content">
        <Switch>
          {LANGS.flatMap((lang) =>
            Object.entries(PAGES)
              .filter(([routeId]) => isLive(routeId, lang))
              .map(([routeId, component]) => (
                <Route
                  key={`${lang}-${routeId}`}
                  exact
                  path={ROUTES[routeId][lang]}
                  component={component}
                />
              )),
          )}
          <Route component={NotFound} />
        </Switch>
      </main>
    </div>
  );
};

export default withRouter(App);
